export const listPipelineTemplates = `
   query listPipelineTemplates($filter: PipelineTemplatesFilterInput, $limit: Int, $nextToken: String) {
       listPipelineTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              name
              description
              pipelineType
              archetype
              buildCommand
              stages {
                name
                order
                buildProvider
                deployProvider
                requiresApproval
              }
              defaultDeploymentAccounts {
                accountId
                accountName
                region
              }
              createdByUsername
              managedByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getPipelineTemplate = `
   query getPipelineTemplate($id:ID!) {
       getPipelineTemplate(id:$id) {
         id
         name
         description
         pipelineType
         archetype
         stages {
           name
           order
           buildProvider
           deployProvider
         }
         defaultDeploymentAccounts {
           accountId
           accountName
           region
         }
         createdByUsername
         managedByUsername
         created
         updated
       }
}`;
